import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "path"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var mapCartRegions = function mapCartRegions(regions) {
  var regionsByGroupName = Object.values(regions.reduce(function (acc, region) {
    var name = region.name,
      path = region.path,
      params = _objectWithoutProperties(region, _excluded);
    var firstLetter = name[0].toUpperCase();
    if (!acc[firstLetter]) {
      acc[firstLetter] = {
        groupName: firstLetter,
        items: []
      };
    }
    var formattedRegion = _objectSpread({
      code: path,
      title: name
    }, params);
    acc[firstLetter].items.push(formattedRegion);
    return acc;
  }, {})).sort(function (a, b) {
    return a.groupName.localeCompare(b.groupName);
  });
  return [{}].concat(_toConsumableArray(regionsByGroupName));
};
export var filterBySearchString = function filterBySearchString(searchString) {
  return function (element) {
    var _element$title;
    return ((_element$title = element.title) === null || _element$title === void 0 ? void 0 : _element$title.toLowerCase().indexOf(searchString.trim().toLowerCase())) > -1;
  };
};